// extracted by mini-css-extract-plugin
export default {"description":"OrgSelectorDialog_description__Vzikl","list":"OrgSelectorDialog_list__Mw+wk","item":"OrgSelectorDialog_item__4XPKf"};